import { Component, OnInit, Input } from '@angular/core';
import { CurrRates } from '../models/symbol-model';
@Component({
  selector: 'lib-modern-currency-rates',
  templateUrl: './modern-currency-rates.component.html'
})
export class ModernCurrencyRatesComponent implements OnInit {
  @Input('currencyRates') currencyRates: Array<CurrRates>;
  public asOfDate: string;
  public displayedColumns: string[] = ['symbolDesc', 'fmtClosePrice'];
  constructor() { }

  ngOnInit() {
    console.log('Currency Rates Initiated for modern', this.currencyRates);
    if ( this.currencyRates && this.currencyRates.length > 0) {
      this.asOfDate = this.currencyRates[0].convertedAsOfDate
    }
  }

}
